import { StyleSheet } from 'aphrodite';
import { hexToRGBA } from '../../../../../models/UiUtils';
import { donorPerfectColor } from '../brandColors';

export const styleSheet = StyleSheet.create({
	ctaButton: {
		background: hexToRGBA(donorPerfectColor, 0.06),
		border: 'none',
		boxShadow: 'none',
		color: donorPerfectColor,
		fontWeight: 400,
		marginTop: 20,
	},
	integrationTitle: {
		color: donorPerfectColor,
	},
	logo: {
		// 12 rather than the 8 of THEME.common.borderRadius, matching the logo badge on the sibling cards.
		borderRadius: 12,
		height: 40,
		marginRight: -10,
		width: 40,
	},
});
